import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $, { data } from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js';
import dash from './dashboardTools.js';
import './nlp/tabler.css';
import BulkBrowse from './BulkBrowse';
import plotly from './plotlyTools.js'

import MD5 from "crypto-js/md5";

function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object && !isarray(o); }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
	var ret = [];
	for (var i = 0; i < n; i++)
		ret.push(v instanceof Object ? clone(v) : v);
	return ret;
}

function bool(s) {
	if (typeof (s) == 'boolean') return s;
	if (!defined(s) || s === null) return false;
	if (typeof (s) == 'number') return s > 0;
	if (s.match(/^y/i)) return true;
	return false;
}

var config = {};

function sbool(v) {
	return ['No', 'Yes'][v];
}
function myAlert(title, message, btn, callback, btn2, callback2, btn3, callback3) {
	if (window.$("#myModal").hasClass('show')) {
		return setTimeout(function () {
			myAlert(title, message, btn, callback, btn2, callback2, btn3, callback3)
		}, 1000);
	}
	$('.modal-title').html(title);
	$('.modal-body').html(message);
	window.$("#myModal").modal({
		backdrop: 'static',
		keyboard: false,
	})
	$(".myclose").css({ position: 'absolute', right: px(10), top: px(0) }).hide();
	$("#modal-close2").hide();
	$("#modal-close3").hide();
	if (!btn) btn = 'Ok';
	if (btn) $("#modal-close").html(btn);
	if (callback) $("#modal-close").unbind('click').on('click', callback);
	if (btn2) {
		$("#modal-close2").html(btn2);
		$("#modal-close2").show();
	}
	if (callback2) $("#modal-close2").unbind('click').on('click', callback2);
	if (btn3) {
		$("#modal-close3").html(btn3);
		$("#modal-close3").show();
	}
	if (callback3) $("#modal-close3").unbind('click').on('click', callback3);
}

function changeUser(fileId, state, col, row) {
	function cb() {
		console.log('dismiss', fileId, col);
		window.post('dismiss_task_worker', { fileId: fileId, user: col }, function (res) {
			console.log('DISMISS', res)
			if (res.data.status) {
				document.location.reload();
				// window.goPage(window.GlobalVars.page);

			}
			else alert('error');
		})
	}
	// if( col == 'qcEmail' && state == 3 )
	if (col == 'qcNameEmail') {
		col = 'qcEmail';
		var email = row.qcEmail;
		if (!email) return false;
		var msg = ['Do you want to dismiss <b>', email, '</b> as QC for this file?'];
		if (state == 3) msg.push('<br><br>This will send the file back to the review pool.')
		myAlert('Dismiss QC', msg.join(''), 'Dismiss QC', cb, 'Cancel');
		return true;
	}
	// else if( col == 'userEmail' && (state == 1 || state==6)) {
	else if (col == 'userNameEmail') {
		col = 'userEmail';
		var email = row.userEmail;
		if (!email) return false;
		var msg = ['Do you want to dismiss <b>', email, '</b> as Annotator for this file?'];
		if (state == 1 || state == 6) msg.push('<br><br>This will send the file back to the annotation pool.')
		myAlert('Dismiss Annotator', msg.join(''), 'Dismiss Annotator', cb, 'Cancel');
		return true;
	}
	return false;
}
var projectType;

var importData = null;
var projectData = null;
var descriptor;
var dashboardVisible = false;
var lcolors = [];
var metricsResult = null;
var findMatch = null;
var nselected = 0;
var selectedTasks = [];

function projectTypeCk( p ) {
	for( var t of arguments ) {
		// console.log( 'checking', projectType, t )
		if( projectType == t ) return true;
	}
	return false;
}

function NlpBrowse(prop) {

	window.getParams();
	projectType = window.GlobalVars.PDFProjectType;
	var global = window.GlobalVars;
	var tab;
	function fileClickTabler(col, row) {
		var fileId = row.fileId;
		window.GlobalVars.PDFFileId = fileId;
		// window.GlobalVars.PDFProjectTableCtx = tab.ctx();
		frm.makeTaskList(tab.baseRows, fileId, window.GlobalVars.PDFProjectName);
		window.saveSession(function () {
			console.log('fileClickTabler', col, row[col], row)
			// if( (col == 'userNameEmail' || col == 'qcNameEmail' ) && row[col] > '' &&  changeUser(row.fileId,row.state,col,row) ) return;
			console.log('FILEID', fileId);
			var page = 'nlpAnnotations';
			if (projectType == 'Media Transcription') page = 'transcription';
			if (projectType == 'AmEx Audio Templete') page = 'transcription2';
			if (projectType == 'Code Switching') page = 'transcription3';
			else if (projectType == 'Pose Estimation') page = 'poseestimation';
			else if (projectType == 'Segmentation') page = 'segmentation';
			else if (projectType == 'Key Point') page = 'keypoint';


			if (row.state == 16) {
				frm.myAlert('Processing', 'This task is still being processed, please try later.')
				return;
			}
			if (row.state == 15) {
				console.log( 'processingError', row.origData.fileId, row.origData.processingError )
				frm.myAlert('Processing Error', 'This task can not be opened due to processing errors.<br>')
				return;
			}
			if (row.state == 14 || row.state == 13) {
				frm.myAlert('Pre-labeling', 'This task is still being processed, please try later.')
				return;
			}
			var params = window.getParams() || {};
			console.log( 'params', params )
			params.fileId = fileId;
			window.goPage(page,params);
		});
	}

	function tabSelect(selectData) {
		var tasks = Object.keys(selectData);
		selectedTasks = tasks;
		nselected = tasks.length;
		if (nselected) {
			$('#actionButton').html('Actions (' + nselected + ') <i class="fa fa-caret-down"></i>').show();
		}
		else {
			$('#actionButton').hide();
		}
		console.log('tabSelect', selectData, nselected);
	}

	async function doAction(type) {
		var msgs = {
			'delete': '<b>Delete</b> ' + nselected + ' selected tasks?',
			'assignLabeling': 'Assign ' + nselected + ' selected tasks to <b>Labeling</b> Team?',
			'assignReview': 'Assign ' + nselected + ' selected tasks to <b>Review</b> Team?',
			'reset': 'Reset ' + nselected + ' selected tasks? This will erase, annotations, history, annotators, reviewers, and state',
		}

		var confs = {
			'delete': 'delete',
			'assignLabeling': 'labeling',
			'assignReview': 'review',
			'reset': 'reset',
		}


		if( 1) {
			if( await frm.myConfirm('Action', msgs[type], confs[type], 'Ok', 'Cancel') ) doAction();
		}
		else {
			frm.myAlert('Action', msgs[type], 'OK', doAction , 'Cancel')
		}

		function doAction() {
			frm.loading('Running action')
			window.post('action_task', { action: type, project:window.GlobalVars.PDFProjectId, tasks: selectedTasks }, res => {

				if (type == 'delete') tab.clearSelection();
				window.saveSession(function () {
					findProjects('Reloading Tasks');

					$('#dashboardButton').html('Show Dashboard');
					$('#dashboard').hide();
					// document.location.reload();
				})
			})
		}
	}

	function actionPopup(ev) {
		var mpos = $('.maincontent').position();
		var pos = $('#actionButton').position();

		var top = mpos.top + pos.top + $('#actionButton').outerHeight();
		var left = mpos.left + pos.left + parseInt($('.maincontent').css('marginLeft'));
		var width = 400;
		var actionPanel = $('<DIV>').addClass('user-panel').css({ top: top, left: left, width: width });
		actionPanel.append($('<DIV>').html('<i class="fa fa-trash"></i> Delete selected tasks (' + nselected + ')').on('click', function () { doAction('delete') }));
		actionPanel.append($('<DIV>').html('<i class="fa fa-pencil"></i> Assign tasks to Labeling team (' + nselected + ')').on('click', function () { doAction('assignLabeling') }));
		if( !projectData.descriptor.disableQC ) {
			actionPanel.append($('<DIV>').html('<i class="fa fa-check"></i> Assign tasks to Reviewing team  (' + nselected + ')').on('click', function () { doAction('assignReview') }));
		}
		if( 1 || window.hasPriv('admin') ) {
			actionPanel.append($('<DIV>').html('<i class="fa fa-refresh"></i> Reset tasks  (' + nselected + ')').on('click', function () { doAction('reset') }));
		}
		// if( window.GlobalVars.userRoles.length > 1 ) actionPanel.append($('<DIV>').html('<i class="fa fa-user-circle"></i> Change role').on('click', function () { window.goPage('userRole') }));
		setTimeout(function () {
			$(document.body).on('click', hideAction);
			$(document.body).append(actionPanel);

			function hideAction() {
				actionPanel.remove();
				$(document.body).off('mousedown');
			}
			console.log('actionPopup', top, left)
		}, 100);
	}

	function tabUpdate(rows) {
		console.log('update', rows.map(r => r.data.origData));
		dashboard();
	}

	function objCmp(a, b) {
		try {
			return JSON.stringify(a) == JSON.stringify(b);
		} catch (e) { console.error(e); return false; }
	}

	function mergeObj(a, b) {
		try {
			for (var k in b) a[k] = b[k];
		} catch (e) { console.error(e) }
	}

	function mergeCount(a, b) {
		try {
			for (var k in b) {
				if (!a[k]) a[k] = b[k];
				else a[k] += b[k];
			}
		} catch (e) { console.error(e) }
	}

	function addCount(o, key, v) {
		try {
			if (!v) v = 1;
			if (isobj(v)) {
				if (!o[key]) o[key] = {};
				for (var k in v)
					o[key][k] = (o[key][k] || 0) + (v[k] || 0);
			}
			else {
				o[key] = (o[key] || 0) + (v || 0);
			}
		} catch (e) { console.error(e) }
	}

	function sortCount(a) {
		try {
			var scount = [];
			for (var k in a) {
				scount.push([k, a[k]]);
				delete a[k];
			}
			scount.sort((a, b) => a[1] > b[1] ? -1 : 1);
			for (var i of scount) a[i[0]] = i[1];
		} catch (e) { console.error(e) }
	}

	var aname = null;
	async function dashboard(but) {
		if (!dashboardVisible) return;
		var db = $('#dashboard');
		db.html('').append($(`
				<div class="container-fluid">
				</div>
		`));

		var ncharts = 0;
		var chartRow = null;
		function addChartDiv() {
			if (!(ncharts % 2)) {
				chartRow = $('<div class="row">');
				db.find('.container-fluid').append(chartRow)
			}
			var divCont = $('<div class="ccol-sm col-6 chart-' + ncharts + '">')
			var div = $('<div class="dashboard-cell">')
			divCont.append(div);
			chartRow.append(divCont);
			ncharts++;
			console.log('divvvvvvvvvvvv222222', div)
			return div;
		}

		// var recs = tab.baseRows.map( r => r.data.origData );
		// console.log( 'dash recs', recs );
		var labels = projectData.labels;
		var annotators = {};
		for( var a in projectData.annotators ) {
			var sa = a.replace(/\*/g, '.');
			annotators[sa] = projectData.annotators[a];
		}
		var qcs = {};
		for( var a in projectData.qcs ) {
			var sa = a.replace(/\*/g, '.');
			qcs[sa] = projectData.qcs[a];
		}

		var states = projectData.states;
		

		if (!aname) {
			var emails = {};
			let nameCount = 1;
			for (var e in annotators) emails[e] = 1;
			for (var e in qcs) emails[e] = 1;
			emails = Object.keys(emails);
			console.log('EMAILS', emails);
			config = (await window.post('fetch_config', { config:{ 
				'misc.obfuscateAnnotatorsThroughputReport':1,
				'misc.hideAnnotatorsThroughputReport':1,
			}})).data;
			let res = await window.post('find_users', { match: { email: { $in: emails } } })
			aname = {};
			for (var u of res.data.records) {
				let name = u.name;
				if( config.misc.obfuscateAnnotatorsThroughputReport ) name = MD5(u.email).toString();
				aname[u.email] = name;
			}
			console.log( 'config', config )
		}

		sortCount(labels);
		console.log('totlabels', labels);
		console.log('annotators', annotators, aname);
		console.log('states', states);

		function val(v) { return v.toFixed(1) }
		function ival(v) { return v.toFixed(0) }
		function labelColor(l) {
			// alert('check');
			if (descriptor.labels && descriptor.labels[l]) return descriptor.labels[l].color;
			if (descriptor.relationships && descriptor.relationships[l]) return descriptor.relationships[l].color;
			if (descriptor.boxes && descriptor.boxes[l]) return descriptor.boxes[l].color;
			return '#ff0000';
		}

		// Task State
		var stateColor = [
			'#cccccc', 
			'#333377', 
			'#ff8833', 
			'#ff8800', 
			'#00cc00', 
			'#cc0000', 
			'#ff8833', 
			'#00cc00', 
			'#cc0000',
			'#cccccc',
			'#cccccc',
			'#cccccc',
			'#cccccc',
			'#cccccc',
			'#cccccc',
			'#cc0000',
			'#cc0000',
		]

		var scolors = [];

		// var cfg = {
		// 	container: addChartDiv(),
		// 	title: 'Task States',
		// 	// max: 100,
		// 	format: ival,
		// 	formatTooltip: ival,
		// 	formatTick: ival,
		// 	paddingY: 30,
		// 	rotated: false,
		// 	// dataColor: function(c,d){ console.log( 'DATACOLOR', c, d ); return lcolors[d.x % lcolors.length]},
		// 	colorPattern: scolors,
		// 	// size:{height:500},
		// 	// basevalue:getVal,
		// 	// hideLegends: true,
		// 	hideY: true,
		// };
		var d = {
			"values": [[]],   // [[1], [2]]
			"xLabels": ['Count'],
			"yLabels": [],
		};

		for (var l in states) {
			console.log('statessssss', states)
			scolors.push(stateColor[l]);
			d.yLabels.push(window.window.stateLabels[l]);
			d.values[0].push(states[l])
		}

		console.log('d before', d)

		// let xValuesArray = [];
		let xDataArray = [];

		// if(Array.isArray(d.values[0])){
		// 	for (let j in d.values[0]) {
		// 		let row = [];
		// 		for (let i in d.values) {
		// 			row.push(d.values[i][j]);
		// 		}
		// 		xValuesArray.push(row);
		// 	}
	
		// 	for(let [index, xValue] of xValuesArray.entries()){
		// 		let trace = {};
		// 		trace = {
		// 			values: xValue,
		// 			domain: {column: index},
		// 			name: 'Count',
		// 			colors: scolors
		// 		}
		// 		xDataArray.push(trace)
		// 	}
		// }else{
		// 	let trace = {};
		// 	trace = {
		// 		values: d.values,
		// 		domain: {column: 0},
		// 		name: 'Count',
		// 		colors: scolors
		// 	}
		// 	console.log('wow', trace)
		// 	xDataArray.push(trace)
		// }

		if(d.values.length > 1){
			for(let [index, xValue] of d.values.entries()){
				let trace = {};
				trace = {
					values: xValue,
					domain: {column: index},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
			}
		}else if(d.values.length == 1){
			let trace = {};
				trace = {
					values: d.values.flat(),
					domain: {column: 0},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
		}

		// if(d.values.length > 0){
		// 	for (let j in d.values[0]) {
		// 		let row = [];
		// 		for (let i in d.values) {
		// 		  row.push(d.values[i][j]);
		// 		}
		// 		xValuesArray.push(row);
		// 	}
	
		// 	for(let [index, xValue] of xValuesArray.entries()){
		// 		let trace = {};
		// 		trace = {
		// 			values: xValue,
		// 			domain: {column: index},
		// 			name: 'Count',
		// 			colors: scolors
		// 		}
	
		// 		xDataArray.push(trace)
		// 	}
		// }

		let data = {
            xData : xDataArray,
            labels: d.yLabels,
            container : addChartDiv()[0],
            grid : { rows: Math.ceil((xDataArray.length)/2), columns: xDataArray.length}
			// grid : { rows: 1, columns: 1}
        }

		console.log('ddata1', d)

		console.log('donutdata', data)

		let config1 = {
			chartTitle: 'Task States',
            size: {
                height: '350',
                width: '650'
            },
		}

		plotly.drawDonutChart(data, config1);
		// dash.drawGraphDonut(d, cfg);

		// labels Dashboard
		var labMax = 15;
		var llist = [];
		for (var l in labels) { llist.push({ name: l, count: labels[l] }) }
		llist.sort((a, b) => a.count > b.count ? -1 : 1)
		var tit = 'Label Distribution';
		if (llist.length > labMax) tit = 'Top Labels';
		llist.splice(labMax, 10000);

		lcolors = [];
		lcolors = frm.paletteWheel(llist.length);
		console.log('colorssssssssssss', lcolors)
		// var cfg = {
		// 	container: addChartDiv(),
		// 	title: tit,
		// 	// max: 100,
		// 	format: ival,
		// 	formatTooltip: ival,
		// 	formatTick: ival,
		// 	paddingY: 30,
		// 	rotated: true,
		// 	dataColor: function (c, d) { return lcolors[d.x % lcolors.length] },
		// 	// size:{height:500},
		// 	// basevalue:getVal,
		// 	hideLegends: true,
		// 	hideY: true,
		// };
		var d = {
			"values": [],
			"xLabels": [],
			"yLabels": ["Label count"]
		};
		for (var l of llist) {
			// lcolors.push( labelColor(l) );
			d.xLabels.push(l.name);
			d.values.push([l.count])
		}
		// for( var l in labels )
		// {
		// 	lcolors.push( labelColor(l) );
		// 	d.xLabels.push(l);
		// 	d.values.push( [labels[l]])
		// }

		// console.log('d before', d)

		// if(d.values.length = 0){
		// 	let trace = {};
		// 	trace = {
		// 		values: d.values,
		// 		color: function (c, d) { return lcolors[d % lcolors.length] },
		// 		orientation: 'h',
		// 	}
		// 	xDataArray2.push(trace);
		// }

		let xValuesArray2 = [];
		let xDataArray2 = [];

		if(Array.isArray(d.values[0])){
			for (let j in d.values[0]) {
				let row = [];
				for (let i in d.values) {
				  row.push(d.values[i][j]);
				}
				xValuesArray2.push(row);
			}

			for(let xValue of xValuesArray2){
				let trace = {};
				trace = {
					values: xValue,
					color: function (c, d) { return lcolors[d % lcolors.length] },
					orientation: 'h',
				}
				xDataArray2.push(trace)
			}
		} else{
			let trace = {};
			trace = {
				values: d.values,
				color: function (c, d) { return lcolors[d % lcolors.length] },
				orientation: 'h',
			}
			xDataArray2.push(trace);
		}

		let data2 = {
            xData : xDataArray2,
            showXlabels: false,
            yValues: d.xLabels,
            yLabel: 'Label count',
            container : addChartDiv()[0]
        }

		console.log('d after', d)

		console.log('bardata', data2)
    
        let config2 = {
            chartTitle: tit,
            size: {
                height: '650',
                width: '350'
            },
            // barmode: false,
            // dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

		plotly.drawBarChart(data2, config2)
		// dash.drawGraphBar(d, cfg);


		// metrics 
		console.log('CKMETRICS', descriptor.disableQC, projectType)
		// if (!descriptor.disableQC && projectType == 'NER') {
			
		if (!descriptor.disableQC && projectTypeCk('NER', 'Comprehend NER', 'OCR','Media Transcription','AmEx Audio Templete','Code Switching')) {
			var tableMetrix = $('<table class="mt-4">')
			tableMetrix.html('')
			db.append(tableMetrix);
			console.log('mert', metricsResult)
			if (metricsResult) metricsNext(metricsResult);
			else window.post('metrics', { project: window.GlobalVars.PDFProjectId, host: document.location.host }, metricsNext);
			function metricsNext(res) {

				metricsResult = res;
				function num(v) { return typeof (v) == 'number' ? v : '-'; }
				function fix2(v) { return typeof (v) == 'number' ? v.toFixed(2) : '-'; }
				var desc = {
					title: 'Quality Metrics',
					columns: {
						name: 'Entity Name',
						TP: 'True Positive',
						TN: 'True Negative',
						FP: 'False Positive',
						FN: 'False Negative',
						p: 'Precision',
						r: 'Recall',
						f1: 'F1 Score',
						Kappa: 'Cohen\'s Kappa Score',
					},
					filter: false,
					search: false,
					sort: true,
					initialSort: 'name',
					initialSortDir: -1,
					pageSize: 10,
					noFilter: null,
					noSearch: null,
					noSort: null,
					centerCol: ['TP', 'TN', 'FP', 'FN', 'p', 'r', 'f1', 'Kappa'],
					formatCol: {
						TP: num,
						TN: num,
						FP: num,
						FN: num,
						p: fix2,
						r: fix2,
						f1: fix2,
						Kappa: fix2,
					},
					forceType: {
						TP: 1,
						TN: 1,
						FP: 1,
						FN: 1,
						p: 1,
						r: 1,
						f1: 1,
						Kappa: 1,
					},
				}
				var tabMetrics = tabler.table(tableMetrix, desc, null);
				if (typeof (res.data) == 'string') {
					try {
						res.data = JSON.parse(res.data);

					} catch (e) { res.data = {} };
				}
				console.log('METRICS', res.data)
				var metricsEntity = {};
				for (var k in res.data) {
					var kdata = res.data[k];
					for (var e of kdata) {
						var name = e[0];
						if( name.match(/(TABLECELL|GENERIC)/)) continue;
						if (!metricsEntity[name]) metricsEntity[name] = { name: name };
						for (var mk in e[1]) metricsEntity[name][mk] = e[1][mk];
					}
				}
				for (var en of Object.values(metricsEntity)) tabMetrics.addRow(en);
				tabMetrics.draw();
			}
		}

		function minutes(v) {
			return Math.floor(v / 60) + ' min.';
		}


		function seconds(v) {
			return Math.floor(v) + ' sec.';
		}

		if( !config.misc.hideAnnotatorsThroughputReport ) {
			
			var divAn = $('<table class="mt-4">')
			divAn.html('annot')
			db.append(divAn);
			var desc = {
				title: 'Annotators Throughput',
				columns: {
					name: 'Name',
					email: 'Email',
					tasks: 'Total Tasks',
					totalTime: 'Total Time',
					avgTime: 'Avg. Time',
				},
				filter: false,
				search: false,
				sort: true,
				initialSort: 'tasks',
				initialSortDir: -1,
				pageSize: 10,
				noFilter: null,
				noSearch: null,
				noSort: null,
				centerCol: ['tasks', 'totalTime', 'avgTime'],
				format: tabler.formatString,
				forceType: { tasks: 1, idx: 1 },
				formatCol: {
					totalTime: seconds,
					avgTime: seconds,
				}
			}
			if( config.misc.obfuscateAnnotatorsThroughputReport ) {
				delete desc.columns.email;
				desc.columns.name = 'Annotator';
			}
			// var tabAnnotator = tabler.table(divAn, desc, 'annotatorThroughput');
			var tabAnnotator = tabler.table(divAn, desc);
			// console.log( 'DESC annotatorThroughput', desc )
	
			var [ttasks, ttime] = [0,0]
			var tidx = 0;
			for (var a in annotators) {
				ttasks += annotators[a].tasks || 0;
				ttime += annotators[a].elapsedTime || 0;
				tabAnnotator.addRow({
					name: aname[a],
					email: a,
					tasks: annotators[a].tasks,
					totalTime: annotators[a].elapsedTime,
					avgTime: annotators[a].elapsedTime / annotators[a].tasks,
					idx: tidx++,
				})
			}
			tabAnnotator.addRow({
				name: 'Total',
				email: '',
				tasks: ttasks,
				totalTime: ttime,
				avgTime: ttime / (ttasks || 1),
				idx: tidx++,
			})
			tabAnnotator.draw();
			
			console.log('TABANNOTATOR', tabAnnotator)
		}
		


		if (Object.keys(qcs).length && !config.misc.hideAnnotatorsThroughputReport) {
			var divQc = $('<table class="mt-4">')
			divQc.html('qc')
			db.append(divQc);

			var desc = {
				title: 'QCs Throughput',
				columns: {
					name: 'Name',
					email: 'Email',
					tasks: 'Total Tasks',
					totalTime: 'Total Time',
					avgTime: 'Avg. Time',
				},
				filter: false,
				search: false,
				sort: true,
				initialSort: 'idx',
				initialSortDir: -1,
				pageSize: 10,
				noFilter: null,
				noSearch: null,
				noSort: null,
				centerCol: ['tasks', 'totalTime', 'avgTime'],
				format: tabler.formatString,
				forceType: { tasks: 1, idx: 1 },
				formatCol: {
					totalTime: seconds,
					avgTime: seconds,
				}
			}
			if( config.misc.obfuscateAnnotatorsThroughputReport ) {
				delete desc.columns.email;
				desc.columns.name = 'Annotator';
			}			
			var tidx = 0;
			// var tabQc = tabler.table(divQc, desc, 'annotatorThroughput');
			var tabQc = tabler.table(divQc, desc);
			let [ttasks, ttime] = [0,0]
			for (var a in qcs) {
				ttasks += qcs[a].tasks || 0;
				ttime += qcs[a].elapsedTime || 0;
				tabQc.addRow({
					name: aname[a],
					email: a,
					tasks: qcs[a].tasks,
					totalTime: qcs[a].elapsedTime,
					avgTime: qcs[a].elapsedTime / qcs[a].tasks,
					idx: tidx++,
				})
			}
			tabQc.addRow({
				name: 'Total',
				email: '',
				tasks: ttasks,
				totalTime: ttime,
				avgTime: ttime / (ttasks || 1),
				idx: tidx++,
			})
			tabQc.draw();
		}




		$('text').css({ fill: '#000000' })

	}


	function exportProject() {

		console.log( 'post', window.postParams( findMatch ))
		var downloadUrl = null;
		frm.myAlert( 'Export Project', 'Exporting, please wait.', 'Cancel')
		var exportProgress = new frm.progressBar( $('.modal-body') );
		$('.modal-footer').hide();
		function check() {
			window.post('export_tasks', findMatch, res => {
				var data = res.data;
				console.log( 'CHECK', data )
				exportProgress.set( data.progress )
				if( data.progress == 1 ) {
					setTimeout(function () {
                    frm.myAlertClose(function () {
                        $('.modal-footer').show();
 
                        // First, navigate to manifest file
                        if (data.url) {
                            document.location = data.url;
                            // After 1 seconds, navigate to Excel file if available dhinesh
                            if (data.xlsxDownloadUrl) {
                                setTimeout(function () {
                                    document.location = data.xlsxDownloadUrl;
                                }, 2000);
                            }
                        } else if (data.xlsxUrl) {
                            // If only Excel file exists
                            document.location = data.xlsxDownloadUrl;
                        }
                    })
                }, 1000)
				}else if(data.progress == 2){
					alert("Data Not Found")
					console.log("Folder not found");
					
				}
				else setTimeout( check, 2000 )
			});
		}
		window.close = frm.myAlertClose;
		check();
		return;
		var cmd = 'export_tasks';
		var url = window.postURL( cmd );
		var pdata = window.postParams( findMatch );

		var getData = [];
		pdata = window.postParams( pdata );
		for( var k in pdata ) getData.push(k+'='+escape(pdata[k]));
		console.log( 'POST', url + '/?' + getData.join('&') )
		document.location = (url + '/?' + getData.join('&'))
		return;
		// window.post('export_tasks', findMatch, res => {
		// 	if (res.data) {
		// 		var projectName = res.data[0].project_name;
		// 		var output = [];
		// 		for (var d of res.data) output.push(JSON.stringify(d));
		// 		var blob = new Blob([output.join('\n')], { type: "text/plain;charset=utf-8" });
		// 		var url = window.URL.createObjectURL(blob);
		// 		var a = document.createElement("a");
		// 		document.body.appendChild(a);
		// 		a.style = "display: none";
		// 		a.href = url;
		// 		a.setAttribute("download", projectName + ".manifest");
		// 		a.click();
		// 		window.URL.revokeObjectURL(url);
		// 	}
		// });
	}



	function getUName(r, email) {
		console.log( 'getUname', 'email', email )
		try {
			var o = []
			var emails = (r[email] || '')
			if( isstring(emails) ) emails = emails.split(',')
			console.log( 'getUName', emails )
			for( var e of emails ) {
				var n = r.userData[e] ? r.userData[e].name : '';
				if( n > '' ) n += ' ';
				o.push(n+frm.smallerText(e))
			}
			// var name = o.join('')
			var name = frm.aLast(o)
		} catch (e) { console.error(e); var name = '' };
		return name;
	}


	function importManifest(imp) {
		window.post('import_manifest', { manifest: imp, project: window.GlobalVars.PDFProjectId }, res => {
			console.log('import res', res.data);
			if (res.data.err.length) return frm.myAlert('Import Error', res.data.err.join('<br>'), 'Ok')
			document.location.reload();
		})
	}

	function fileInputChange(ev) {
		var files = ev.target.files; // FileList object
		var f = files[0];
		var reader = new FileReader();
		reader.onload = function (e) {
			var imp = [];
			e.target.result.split('\n').forEach(function (i) {
				try { imp.push(JSON.parse(i)); }
				catch (e) {
					if (i > '') console.error('invalide manifest line', JSON.stringify(i))
					return null
				}
			});
			$(ev.target).val('');
			importManifest(imp);
		};
		reader.readAsText(f);
	}

	var findFirstTime = true;
	function findProjects(loadStr) {
		importData = null;
		projectData = null;
		dashboardVisible = false;
		lcolors = [];
		metricsResult = null;
		findMatch = null;
		nselected = 0;
		selectedTasks = [];
		// $('#documentlist').html('');
		if( !loadStr ) loadStr = 'Loading Tasks';
		frm.loading(loadStr)

		$('#topbuttons').html('');

		window.reprocessTasks = function () {
			window.post('reprocess_project', { project: window.GlobalVars.PDFProjectId, clear: 1 }, console.log)
		}
		if (window.hasPriv('admin', 'c_admin','c_super')) {
			var projBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 btn btn-primary">Browse Projects</Button>')
			projBut.on('click', () => {
				window.GlobalVars.PDFProjectId = null;
				window.GlobalVars.PDFProjectTableCtx = null;
				window.GlobalVars.PDFFileId = null;
				window.saveSession();
				window.goPage('nlpProjectBrowse');
			})
			var exportBut = $('<Button id="browseProjects" type="submit" class="ml-2 mt-2 btn btn-pink">Export Project Data</Button>')
			exportBut.on('click', exportProject);
			var fileImport = $('<INPUT id="importmanifest" type="file">').css({ position: 'absolute', top: -10000, left: -10000 });
			var importBut = $('<Button id="browseProjects" type="submit" class="ml-2 mt-2 btn btn-secondary">Import Project Data</Button>')
			importBut.on('click', function () {
				fileImport[0].click();
			});
			fileImport.on('change', fileInputChange);

			var dashBut = $('<Button id="dashboardButton" type="submit" class="ml-2 mt-2 btn btn-primary">Show Dashboard</Button>')
			dashBut.on('click', function () {
				dashboardVisible = !dashboardVisible;
				if (dashboardVisible) {
					dashBut.html('Hide Dashboard');
					$('#dashboard').show();
					dashboard()
				}
				else {
					dashBut.html('Show Dashboard');
					$('#dashboard').hide();
				}
			});
			var dashAction = $('<Button id="actionButton" type="submit" class="ml-2 mt-2 btn btn-pink" style="display:none">Action <i class="fa fa-caret-down"></i></Button>')
			dashAction.on('click', actionPopup);
			// 
			// $('#topbuttons').append(projBut,exportBut);
			// $('#topbuttons').append(exportBut, fileImport, importBut, dashBut, dashAction);
			$('#topbuttons').append(exportBut, fileImport, dashBut, dashAction);
		}

		var match = {};
		var pmatch = {};
		if (window.GlobalVars.PDFProjectId) {
			match.project = window.GlobalVars.PDFProjectId;
			pmatch.id = window.GlobalVars.PDFProjectId;
		}
		window.post('find_projects', { match: pmatch }, function (pres) {
			// console.log( 'PRES', pres )
			projectData = pres.data.records[0];
			frm.dotKeys(projectData)
			window.ddd = descriptor = (pres.data && pres.data.records && pres.data.records[0] && pres.data.records[0].descriptor) || {};
			findMatch = { match: match, listOnly: true };
			window.findMatch = findMatch;
			console.log( 'projectData', projectData )
			window.post('find_tasks', findMatch, function (res) {
				frm.loadingOut();
				var pdfs = res.data.records;
				console.log('PDFS', pdfs);
				if (!pdfs.length) {
					$('.alert').remove();
					var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No documents found');
					$('#topbuttons').prepend(empty);
					$('#documentlist').hide();
				}
				var annotations = [];

				function formatUName(name, email) {
					if (!email) return '-';
					return name + ' ' + frm.smallerText(email);
				}

				pdfs.forEach(p => {
					// frm.dotKeys(p);
					console.log( 'PPPP', clone(p) )
					// p.annotations.forEach( (a,idx) => {
					var a = p.annotations;
					// if( !a ) return;
					var labels = a && a.tags ? a.tags.length : 0;
					var relationships = a && a.links ? a.links.length : 0;
					var boxes = a && a.boxes ? a.boxes.length : 0;
					var totan = labels + relationships + boxes;
					var sannot = p.annotationCount || 0;
					if (p.labels && Object.keys(p.labels).length) {
						const labelStr = Object.keys(p.labels).join(', ');
						if (labelStr && labelStr.toLowerCase() !== 'undefined') {
							sannot += ' - ' + labelStr;
						}
					}	
					var touched = 0;
					if (p.modified > touched) touched = p.modified;
					if (p.assigned > touched) touched = p.assigned;

					var nSubmit = p.taskAnnotations ? p.taskAnnotations.filter(t => t.role == 'nlp_an').length : 0;
					// console.log( 'NANNOT', nSubmit, p.taskAnnotations );
					// var prev = p.preview == 'Image file' ? 'adlthumb:'+p.fileId : p.preview;
					var prev = p.preview;
					var aobj = {
						// id: p.id,
						name: p.name,
						fileId: p.fileId,
						project: p.projectName,
						source: p.source.match(/^file/) ? p.name : p.source,
						userId: p.userId,
						thumb: [p.fileId, p.thumb, p.type],
						userNameEmail: getUName(p, 'userEmail'),
						userEmail: p.userEmail,
						qcId: p.qcId,
						qcNameEmail: getUName(p, 'qcEmail'),
						qcEmail: p.qcEmail,
						nSubmit: nSubmit,
						labels: labels,
						preview: prev,
						relationships: relationships,
						boxes: boxes,
						annotations: sannot,
						// labels: alab,
						origData: p,
						touched: touched * 1,
						// lastChanged: window.timeFromNow(touched),
						// stateLabel: window.stateLabels[p.state],
						state: p.state,
					}
					// if( global.userPriv.nlp_qc && (aobj.qc_feedback == 'yes' || !a) ) return;
					// if( global.userPriv.nlp_an && a ) return;
					annotations.push(aobj);
					// })
				})
				var tbody = $('#results');
				console.log('ANNOTATIONS', annotations);
				annotations.sort(function (a, b) {
					if (a.project != b.project) return a.project < b.project ? -1 : 1;
					if (a.source != b.source) return a.source < b.source ? -1 : 1;
					if (a.userId != b.userId) return a.userId < b.userId ? -1 : 1;
				});
				// annotations.forEach( a => {
				//     var id = a.fileId;
				//     var tr = $('<TR>').addClass('clickable').prop('fileId',id).on('click',fileClick);
				//     for( var k in a )
				//     {
				//         if( k.match(/^(fileId|state)$/) ) continue;
				//         var v = a[k];
				//         var td = $('<TD>').html(v);
				//         tr.append(td);
				//     }
				//     td.addClass('state_'+a.state);
				//     tbody.append(tr);
				// })

				var desc = {
					title: 'Project Tasks',
					columns: {
						// project: 'Project',
						// name: 'File Name',
						thumb: 'Thumb.',
						// fileId:'fileId',
						source: 'Source',
						preview: 'Text Preview',
						userNameEmail: 'Annotator',
						qcNameEmail: 'QC',
						// labels: 'Labels',
						// relationships: 'Relationships',
						// boxes: 'Boxes',
						nSubmit: 'Total Submitions',
						annotations: 'Annotations',
						touched: 'Updated',
						state: 'State',
					},
					selectMode: true,
					selectId: 'fileId',
					filter: true,
					search: true,
					sort: true,
					initialSort: 'touched',
					initialSortDir: -1,
					pageSize: 10,
					noFilter: {
						nSubmit: 1,
						touched: 1,
						thumb:1,
					},
					noSearch: { thumb: 1 },
					noSort: null,
					centerCol: ['thumb', 'annotations', 'state', 'touched'],
					format: tabler.formatString,
					forceType: { touched: 1 },
					formatCol: {
						thumb: frm.formatThumb,
						touched: tabler.formatTimeAgoSec,
						state: tabler.formatState,
						preview: frm.formatPreview,
						annotations: frm.smallerText,
					}
					// clickCol: ['stateLabel','source'],
				}
				// if( projectType == 'Media Transcription') desc.forceType.annotations = 1;
				var nannot = descriptor.annotatorsPerTask || 1;
				if (nannot == 1) delete desc.columns.nSubmit;
				tab = tabler.table($('#documentlist'), desc, 'tasks');
				annotations.forEach(a => {
					a.stateLabel = '<span class="state_' + a.state + '">' + a.stateLabel + '</span>';
					tab.addRow(a, function (col, row) {
						console.log('tabler click', a.fileId, row[col])
						fileClickTabler(col, row)
					})
				});
				tab.onSelect(tabSelect)
				tab.onUpdate(tabUpdate);
				tab.onDraw(frm.loadThumbnails);
				tab.draw();
				console.log('TAB', tab)
			});
		});
	}

	var ret = (
		<div fluid="md p-0" className="maincontent">
			<div id="topbuttons"></div>
			<div id="dashboard"></div>
			<Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
			</Table>
			<span>&nbsp;</span>
		</div>
	);

	if( global.PDFProjectType == 'Bulk Image Classification') {
		findProjects = function(){}
		ret = (
				<BulkBrowse/>
		)
	}
	useEffect(findProjects);
	return ret
}

export default NlpBrowse
